import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-in-view'] ? 'visible' : 'hidden',
})) `
  display: contents;
`;
export const MotionWrapperStyles = {
    Container,
};
